import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import Icon from '../icons/icon'

const CtaButtonSecondary = props => (
  <button
    className={classNames('cta-button-secondary', props.className, {
      'is-active': props.isActive,
      'multiline-button': props.multiline,
      'is-loading': props.isLoading,
      disabled: props.disabled
    })}
    onClick={props.onClick}
    disabled={props.disabled}
  >
    <span>{props.text}</span>
    {props.isLoading && <span className='loading-symbol' />}
    {props.iconName && !props.isLoading && <Icon name={props.iconName} />}
  </button>
)

CtaButtonSecondary.propTypes = {
  onClick: PropTypes.func,
  iconName: PropTypes.string,
  text: PropTypes.string,
  isActive: PropTypes.bool,
  multiline: PropTypes.bool,
  disabled: PropTypes.bool,
  isLoading: PropTypes.bool
}

export default CtaButtonSecondary



// WEBPACK FOOTER //
// ./src/ui/buttons/cta-button-secondary.js